import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { CollaboratorPage } from '~/components/routes/logistics/collaborator-page'
import {
  LogisticsRecordRoute,
  logisticsRecordIdParam,
} from '~/components/routes/logistics/logistics-record-page'
import { LOGISTICS_COLLABORATOR_READ } from '~/components/routes/logistics/tabs'
import { withRoutePermissions } from '~/utils/rbac'
import { logisticsSearchSchema } from '../-search-schema'

export const Route = createFileRoute('/_authenticated/logistics/collaborators/$collaboratorId')({
  staticData: {
    permission: LOGISTICS_COLLABORATOR_READ,
  },
  component: CollaboratorDetailRoute,
  params: {
    parse: z.object({ collaboratorId: logisticsRecordIdParam() }).parse,
  },
  // Mêmes paramètres que la page Logistique : les filtres de la liste suivent l'aller-retour.
  validateSearch: logisticsSearchSchema,
})
withRoutePermissions(Route)

function CollaboratorDetailRoute() {
  const { collaboratorId } = Route.useParams()
  return (
    <LogisticsRecordRoute
      tab="hr"
      search={Route.useSearch()}
      permission={LOGISTICS_COLLABORATOR_READ}
    >
      {(search) => <CollaboratorPage collaboratorId={collaboratorId} search={search} />}
    </LogisticsRecordRoute>
  )
}
